module.exports = __webpack_public_path__ + "static/media/vinodbhimjyani.e89012e2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/vinodbhimjyani.jpg
// module id = 1131
// module chunks = 0